<div class="hamburger-wrapper">
  <!-- Header with Back button -->
  @if(menuStack.length > 0){
  <div class="header w-100">
    <button class="back-btn pr-0 pl-1" (click)="goBack()">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 13L1 7L7 1" stroke="#ea651f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>        
    </button>
    <div class="title">{{ currentTitle }}</div>
  </div>
  }
  <!-- Scrollable menu list -->
  <div class="menu-scroll-area w-100">
    <ul class="menu-list">
      @for(item of currentMenu ; track item){
      <li class="mb-0">
        <div class="menu-item">
          @if(item?.isdownload){
          <span (click)="downloadpdf(item)">
            {{ item.name }}
          </span>
          }@else if(!item?.isRoutable){
          <a [href]="item.url" target="_blank">{{item.name}}</a>
          }@else {
          <span (click)="handleItemClick(item)">
            {{ item.name }}
          </span>
          }
          <!-- Show arrow for submenu -->
          @if(item.hasSubMenu || item.hasNextedMenu || item.hasNestedSubMenu){
          <span class="arrow" (click)="handleItemClick(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
              <path d="M1 13L7 7L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          }

        </div>
      </li>
      }
    </ul>
  </div>

  <!-- Footer buttons (only on main menu) -->
  @if (menuStack.length === 0) {
  <div class="footer-buttons w-100">

    @if(service.isUserLoggedIn()){
      <app-naps-button [isRoutable]="false"
      (clicked)="logOut()" [buttonName]="buttons.logout">
        <span class="dasboard-span">
          LogOut
        </span>
      </app-naps-button>
    }@else {
      <div class="login-wrapper">
        <app-naps-button
          [isFilledButton]="true"
          (clicked)="accordion.set(!accordion())"
          [buttonName]="buttons.login.key">
          <span>
            {{buttons.login.key.name}}&nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none" class="ml-2">
              <path d="M1 1L7 7L13 1" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </app-naps-button>
      
        @if(accordion()){
          <ul class="naps-dropdown-list-overlay">
            @for(data of buttons.login.dropDown;track data){
              <li class="py-2 mb-0">
                <a class="dropdown-item" [routerLink]="data.routeLink"> {{ data.name }} </a>
              </li>
            }
          </ul>
        }
      </div>      
    }
    @if(!service.isUserLoggedIn()) {
      <app-naps-button [isbuttonWithTag]="true" [tag_Button_Name]="buttons.mela"></app-naps-button>
      <app-naps-button [isOpenNewTab]="true" [buttonName]="buttons.dashBoard">
        <span class="dasboard-span">
          <span class="dasboard-span">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M20.2104 14.8901C19.5742 16.3946 18.5792 17.7203 17.3123 18.7514C16.0454 19.7825 14.5452 20.4875 12.9428 20.8048C11.3405 21.1222 9.68483 21.0422 8.12055 20.5719C6.55627 20.1015 5.13103 19.2551 3.96942 18.1067C2.80782 16.9583 1.94522 15.5428 1.45704 13.984C0.968859 12.4252 0.869965 10.7706 1.169 9.1647C1.46804 7.55885 2.1559 6.0507 3.17245 4.7721C4.189 3.4935 5.50329 2.48339 7.0004 1.83007M20.2392 7.17323C20.6395 8.1397 20.8851 9.16143 20.9684 10.2009C20.989 10.4577 20.9993 10.5861 20.9483 10.7018C20.9057 10.7984 20.8213 10.8898 20.7284 10.94C20.6172 11.0001 20.4783 11.0001 20.2004 11.0001H11.8004C11.5204 11.0001 11.3804 11.0001 11.2734 10.9456C11.1793 10.8976 11.1028 10.8211 11.0549 10.7271C11.0004 10.6201 11.0004 10.4801 11.0004 10.2001V1.80007C11.0004 1.5222 11.0004 1.38327 11.0605 1.27205C11.1107 1.17915 11.2021 1.09476 11.2987 1.05216C11.4144 1.00117 11.5428 1.01146 11.7996 1.03205C12.839 1.11539 13.8608 1.36095 14.8272 1.76127C16.0405 2.26382 17.1429 3.00042 18.0715 3.929C19.0001 4.85759 19.7367 5.95998 20.2392 7.17323Z"
                stroke="#EA651F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          {{buttons.dashBoard.name}}
        </span>
      </app-naps-button>
    }
  </div>

  <div class="footer-content w-100">
    <p>Platform is Owned by </p>
    <h3>Ministry of Skill Development and Entrepreneurship, Government of India</h3>
    <p>© Copyright 2025 - All Rights Reserved</p>
  </div>
  }
</div>